const FADE_SIZE = 24;

function buildMask(atTop, atBottom) {
	const topStop = atTop ? 'black' : `transparent, rgba(0,0,0,0.15) ${FADE_SIZE * 0.7}px, black ${FADE_SIZE}px`;
	const bottomStop = atBottom ? 'black' : `black calc(100% - ${FADE_SIZE}px), rgba(0,0,0,0.15) calc(100% - ${FADE_SIZE * 0.7}px), transparent`;

	return `linear-gradient(to bottom, ${topStop}, ${bottomStop})`;
}

export default {
	mounted(el) {
		const update = () => {
			const atTop = el.scrollTop <= 0;
			const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;

			el.style.maskImage = buildMask(atTop, atBottom);
		};

		update();
		el._scrollFadeHandler = update;
		el.addEventListener('scroll', update, { passive: true });

		// Re-check when content or size changes
		el._scrollFadeObserver = new ResizeObserver(update);
		el._scrollFadeObserver.observe(el);
	},
	unmounted(el) {
		el.removeEventListener('scroll', el._scrollFadeHandler);
		if (el._scrollFadeObserver) {
			el._scrollFadeObserver.disconnect();
		}
	},
};
